import { render, staticRenderFns } from "./prescription-list-page.vue?vue&type=template&id=fe62206e&scoped=true&"
import script from "./prescription-list-page.vue?vue&type=script&lang=js&"
export * from "./prescription-list-page.vue?vue&type=script&lang=js&"
import style0 from "./prescription-list-page.vue?vue&type=style&index=0&id=fe62206e&lang=scss&scoped=true&"
import style1 from "./prescription-list-page.vue?vue&type=style&index=1&id=fe62206e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe62206e",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard})
